module.exports = "/images/vendor/flag-icon-css/flags/1x1/mo.svg?67acac75dc2e1cb667560972d6996ea6";